// import React, { useState, useEffect } from "react";
// import { Calendar, momentLocalizer } from "react-big-calendar";
// import moment from "moment";
// import "react-big-calendar/lib/css/react-big-calendar.css";
// import axios from "axios";
// import { CheckToken } from "../login/AccessToken";
// import "./weekCalender.css";

// const WeekCalendar = ({ id, date, reload }) => {
//   const [authToken, setAuthToken] = useState(
//     sessionStorage.getItem("accessToken") ?? ""
//   );
//   const [calendarView, setCalendarView] = useState("week");
//   const [doctorAppointmentList, setDoctorAppointmentList] = useState([]);
//   const [totalAppointments, setTotalAppointments] = useState(0);

//   const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
//   const headers = { Authorization: `Bearer ${authToken}` };

//   const Token = () => {
//     const check = CheckToken();
//     setAuthToken(sessionStorage.getItem("accessToken"));
//     return check;
//   };

//   useEffect(() => {
//     fetchDoctorAppointmentDetails();
//   }, [id, date, reload]);

//   function fetchDoctorAppointmentDetails() {
//     const userRole = sessionStorage.getItem("roleType");
//     const requestID =
//       userRole === "doctor" ? sessionStorage.getItem("doctor_id") : id;

//     if (Token()) {
//       axios
//         .post(
//           `${REACT_APP_BACKEND_ROUTE_URL}get_doctor_appointments/`,
//           { id: requestID },
//           { headers }
//         )
//         .then((response) => {
//           setDoctorAppointmentList(response.data.appointments);
//           setTotalAppointments(response.data.total_appointments);
//         })
//         .catch((error) => {
//           console.log("FETCH FAILED", error);
//         });
//     }
//   }

//   const localizer = momentLocalizer(moment);

//   // Event block colors
//   const eventPropGetter = (event) => {
//     let color = "#E9F5FE"; // Scheduled
//     if (event.status === "CANCELLED") color = "#FFD2B0";
//     else if (event.status === "COMPLETED") color = "#F0F8F0";
//     return { style: { backgroundColor: color, borderRadius: "12px" } };
//   };

//   // Custom event block renderer
//   const EventComponent = ({ event }) => {
//     return (
//       <div style={{ padding: "6px", color: "#000" }}>
//         <div style={{ fontWeight: "400", fontSize: "10px", color: "#000" }}>
//           PATIENT ID - {event.patient}
//         </div>
//         {/* <div style={{ fontSize: "11px", marginTop: "2px", color: "#000" }}>
//           {moment(event.start).format("HH:mm")} -{" "}
//           {moment(event.end).format("HH:mm")}
//         </div> */}
//       </div>
//     );
//   };

//   // Map appointments to calendar format
//   const mappedAppointments = doctorAppointmentList.map((appointment) => ({
//     title: `PATIENT ID - ${appointment.patient}`,
//     start: new Date(appointment.start_time_ist),
//     end: new Date(appointment.end_time_ist),
//     status: appointment.status,
//     patient: appointment.patient,
//   }));

//   return (
//     <div
//       style={{
//         maxWidth: "765px",
//         background: "#fff",
//         borderRadius: "16px",
//         boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
//       }}
//     >
//       {/* Calendar */}
//       <Calendar
//         localizer={localizer}
//         events={mappedAppointments}
//         startAccessor="start"
//         endAccessor="end"
//         style={{ height: "90vh" }}
//         view={calendarView}
//         onView={(view) => setCalendarView(view)}
//         eventPropGetter={eventPropGetter}
//         components={{
//           event: EventComponent,
//         }}
//       />

//       {/* Legend */}
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "center",
//           gap: "32px",
//           paddingBottom: "10px",
//           marginTop: "20px",
//         }}
//       >
//         <Legend color="#FFD2B0" label="Cancelled" />
//         <Legend color="#E9F5FE" label="Scheduled" />
//         <Legend color="#F0F8F0" label="Completed" />
//       </div>
//     </div>
//   );
// };

// const Legend = ({ color, label }) => (
//   <span
//     style={{
//       display: "inline-block",
//       padding: "4px 12px",
//       border: `1px solid ${color}`,
//       borderRadius: "10px",
//       fontSize: "13px",
//       fontWeight: "500",
//       color: color,
//       backgroundColor: `${color}15`,
//     }}
//   >
//     {label}
//   </span>
// );

// export default WeekCalendar;
import React, { useState, useEffect } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import axios from "axios";
import { CheckToken } from "../login/AccessToken";
import "./weekCalender.css";

const WeekCalendar = ({ id, date, reload }) => {
  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") ?? ""
  );
  const [calendarView, setCalendarView] = useState("week");
  const [doctorAppointmentList, setDoctorAppointmentList] = useState([]);
  const [totalAppointments, setTotalAppointments] = useState(0);

  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  const headers = { Authorization: `Bearer ${authToken}` };

  const Token = () => {
    const check = CheckToken();
    setAuthToken(sessionStorage.getItem("accessToken"));
    return check;
  };

  useEffect(() => {
    fetchDoctorAppointmentDetails();
  }, [id, date, reload]);

  function fetchDoctorAppointmentDetails() {
    const userRole = sessionStorage.getItem("roleType");
    const requestID =
      userRole === "doctor" ? sessionStorage.getItem("doctor_id") : id;

    if (Token()) {
      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}get_doctor_appointments/`,
          { id: requestID },
          { headers }
        )
        .then((response) => {
          setDoctorAppointmentList(response.data.appointments);
          setTotalAppointments(response.data.total_appointments);
        })
        .catch((error) => {
          console.log("FETCH FAILED", error);
        });
    }
  }

  const localizer = momentLocalizer(moment);

  // Apply status-based CSS class instead of inline color
  const eventPropGetter = (event) => {
    let className = "event-scheduled";
    if (event.status === "CANCELLED") className = "event-cancelled";
    else if (event.status === "COMPLETED") className = "event-completed";

    return { className };
  };

  // Custom event block renderer
  const EventComponent = ({ event }) => {
    return (
      <div style={{ padding: "6px", color: "#000" }}>
        <div style={{ fontWeight: "400", fontSize: "10px", color: "#000" }}>
          PATIENT ID - {event.patient}
        </div>
      </div>
    );
  };

  // Map appointments to calendar format
  const mappedAppointments = doctorAppointmentList.map((appointment) => ({
    title: `PATIENT ID - ${appointment.patient}`,
    start: new Date(appointment.start_time_ist),
    end: new Date(appointment.end_time_ist),
    status: appointment.status,
    patient: appointment.patient,
  }));

  return (
    <div
      style={{
        maxWidth: "100%",
        background: "#fff",
        borderRadius: "16px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
      }}
    >
      {/* Calendar */}
      <Calendar
        localizer={localizer}
        events={mappedAppointments}
        startAccessor="start"
        endAccessor="end"
        style={{ height: "90vh" }}
        view={calendarView}
        onView={(view) => setCalendarView(view)}
        eventPropGetter={eventPropGetter}
        components={{
          event: EventComponent,
        }}
      />

      {/* Legend */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "32px",
          paddingBottom: "10px",
          marginTop: "20px",
        }}
      >
        <Legend color="#F97316" bg="#FFD2B0" label="Cancelled" />
        <Legend color="#60A5FA" bg="#E9F5FE" label="Scheduled" />
        <Legend color="#22C55E" bg="#F0F8F0" label="Completed" />
      </div>
    </div>
  );
};

const Legend = ({ color, bg, label }) => (
  <span
    style={{
      display: "inline-block",
      padding: "4px 12px",
      border: `2px solid ${color}`,
      borderRadius: "10px",
      fontSize: "13px",
      fontWeight: "500",
      color: color,
      backgroundColor: `${bg}`,
    }}
  >
    {label}
  </span>
);

export default WeekCalendar;
